'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PublikationsuploadSchema = {
  title: 'Publikationsupload',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/publikationsupload.js
// module id = FERb
// module chunks = 0